<!-- Header -->
<div class="viewer-header">
  <div class="header-patient">
    <div class="patient-avatar">
      <mat-icon>person</mat-icon>
    </div>
    <div class="patient-info">
      <span class="patient-name">{{ patient?.description }}</span>
      <span class="patient-id">ID : #{{ patient?.id }}</span>
    </div>
  </div>
  <div class="header-actions">
    <button mat-raised-button color="primary" (click)="openDicomViewer()">
      <mat-icon>monitor_heart</mat-icon>
      Ouvrir le Visionneur DICOM
    </button>
    <button mat-icon-button *ngIf="dismissible" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<!-- Body -->
<div class="viewer-body">

  <!-- Left sidebar: patient metadata -->
  <aside class="sidebar">
    <div class="sidebar-content">

      <section class="sidebar-section">
        <h3 class="section-label">Aperçu du Patient</h3>
        <div class="meta-grid">
          <div class="meta-item">
            <span class="meta-caption">Date de naissance</span>
            <span class="meta-value">{{ patient?.birthday | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-caption">Sexe</span>
            <span class="meta-value">{{ patient?.sex }}</span>
          </div>
        </div>
      </section>

      <mat-divider></mat-divider>

      <section class="sidebar-section">
        <h3 class="section-label">Contexte Clinique</h3>
        <div class="meta-row">
          <mat-icon class="meta-icon">domain</mat-icon>
          <div>
            <span class="meta-caption">Série</span>
            <span class="meta-value">{{ currentSerie?.name }}</span>
          </div>
        </div>
        <div class="meta-row">
          <mat-icon class="meta-icon">image</mat-icon>
          <div>
            <span class="meta-caption">Images</span>
            <span class="meta-value">{{ imageCount }} image(s)</span>
          </div>
        </div>
      </section>

      <mat-divider></mat-divider>

      <section class="sidebar-section">
        <h3 class="section-label">État de l'Examen</h3>
        <div class="status-badge verified">
          <mat-icon>verified</mat-icon>
          <span>Vérifié</span>
        </div>
        <div class="status-badge date">
          <mat-icon>calendar_today</mat-icon>
          <span>{{ contactDate | date:'dd MMM yyyy' }}</span>
        </div>
      </section>

    </div>
  </aside>

  <!-- Viewer area -->
  <div class="viewer-area">

    <!-- Series rail -->
    <aside class="series-rail">
      <app-rx-image-table [serie]="currentSerie" (selected)="showImage($event)"></app-rx-image-table>
    </aside>

    <!-- Main image display -->
    <section class="main-viewer">
      <div class="image-container">
        <app-rx-image-viewer #viewer [image]="selectedImage"></app-rx-image-viewer>
      </div>

      <!-- Metadata overlay -->
      <div class="viewer-overlay" *ngIf="selectedImage">
        <div class="overlay-row"><span>SÉRIE :</span><span>{{ currentSerie?.name }}</span></div>
        <div class="overlay-row"><span>COUPE :</span><span>{{ imageIndex }} / {{ imageCount }}</span></div>
      </div>

      <!-- Image controls -->
      <div class="viewer-controls">
        <button mat-icon-button matTooltip="Zoom avant" (click)="viewer.zoomIn()"><mat-icon>zoom_in</mat-icon></button>
        <button mat-icon-button matTooltip="Zoom arrière" (click)="viewer.zoomOut()"><mat-icon>zoom_out</mat-icon></button>
        <button mat-icon-button matTooltip="Réinitialiser" (click)="viewer.reset()"><mat-icon>restart_alt</mat-icon></button>
      </div>
    </section>

  </div>
</div>

<!-- Footer -->
<div class="viewer-footer">
  <div></div>
  <div class="footer-actions">
    <button mat-button color="primary" (click)="protocolRequested.emit()">
      <mat-icon>picture_as_pdf</mat-icon>
      Télécharger le Protocole
    </button>
    <mat-divider vertical></mat-divider>
    <button mat-button color="primary" (click)="exportDicom()">
      <mat-icon>download</mat-icon>
      Exporter l'ensemble DICOM
    </button>
    <mat-divider vertical></mat-divider>
    <button mat-button *ngIf="dismissible" (click)="close()">Fermer</button>
  </div>
</div>
